import { Clock } from 'lucide-react';

interface PlanPartButtonProps {
  /** The plan's part and time ("Dinner · 7:30 PM"), or null when it has neither. */
  description: string | null;
  /** Focus mode: no words beside the icon unless the plan has a part. */
  compact?: boolean;
  onClick: () => void;
}

/** The toolbar's way to the part of the evening a plan lays out, naming it once set. */
export function PlanPartButton({ description, compact = false, onClick }: PlanPartButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-1 px-3 py-2 border border-gray-300 text-gray-700 text-sm rounded-md hover:bg-gray-50"
      data-testid="plan-part-btn"
      aria-label={description ? `Part of the evening: ${description}` : 'Part of the evening'}
      title="Which part of the evening this plan lays out, and when it begins"
    >
      <Clock size={14} />
      {description ?? (!compact && 'Part of the evening')}
    </button>
  );
}
